<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import DocumentGrid from '../Document/DocumentGrid'
import DocumentUpload from '../Document/DocumentUpload'

export default {
  name: 'StudentDocumentsTab',
  components: {
    DocumentGrid,
    DocumentUpload
  },
  data () {
    return {
      roleForm: this.$store.state.students.roleForm,
      hideEntity: true
    }
  },
  computed: {
    ...mapState('students', {
      studentId: state => state.studentForm.STUDENT_ID
    }),
    ...mapState('documents', {
      documentUploadState: s => s.uploadModal.open
    }),
  },
  methods: {
  }
}
</script>

<template>
  <div class="fit">
    <DocumentGrid :entityItemId="studentId" :deleteable="true" />
    <document-upload v-if="documentUploadState" :hideEntity="hideEntity" :entityItemId="studentId"/>
  </div>
</template>

<style>
</style>
